// Tiny wrapper around Google Analytics gtag.js.
//
// Contract: every call is a silent no-op when `window.gtag` is unavailable
// (offline dev, ad-block, SSR, tests). Callers never need to guard.
//
// Do NOT pass PII (email, username, password, session tokens, real names).
// Only pass low-cardinality identifiers, role, and behavioural context.
//
// Event naming: lowercase snake_case, prefixed with the surface where the
// event originated (e.g. `market_track_inspect`, `market_week_pick`).

const gtagAvailable = () =>
    typeof window !== "undefined" && typeof window.gtag === "function";

/** Fire a gtag custom event. `params` should be a flat object of primitive
 *  values (string / number / boolean). Nested objects are silently dropped
 *  by GA — flatten them at the call site if you need structure. */
export const trackEvent = (eventName, params = {}) => {
    if (!eventName || typeof eventName !== "string") return;
    if (!gtagAvailable()) return;
    try {
        window.gtag("event", eventName, params);
    } catch (_err) {
        // Never let analytics break the app.
    }
};

/** Fire a gtag page-view (SPAs need this whenever the route changes). */
export const trackPageView = (path, title) => {
    if (!gtagAvailable()) return;
    try {
        window.gtag("event", "page_view", {
            page_path: path,
            page_title: title,
        });
    } catch (_err) {
        // no-op
    }
};

export default { trackEvent, trackPageView };
